import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MessageModel } from '../types';
import { BaseMessageComponent } from '../base-message';

@Component({
  selector: 'message-text',
  templateUrl: './message-text.component.html',
  styleUrls: ['./message-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MessageTextComponent extends BaseMessageComponent {
  tagNameForExit = 'message-text';

  @Input() message!: MessageModel;
}
